module.exports = __webpack_public_path__ + "static/media/err.28ac94ff.png";